"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classNames = require("classnames");
var dom_1 = require("../dom");
/**
 * This function can be used to wrap a component to handle its open state.
 *
 * Given any component that has two properties `isOpen` and `onToggleOpen`,
 * the connect function returns a new component that handles the state of the
 * isOpen property. Thereby, it creates a "managed" component from a "dumb"
 * component.
 *
 * Initially, the property `isOpen` is set to false. Whenever the component to
 * wrap calls `onToggleOpen`, the value of `isOpen`is switched.
 */
function withManagedIsOpenState(ComponentToWrap) {
    var _a;
    var propTypes = __assign({}, ComponentToWrap.propTypes, { isInitiallyOpen: PropTypes.bool });
    delete propTypes.isOpen;
    delete propTypes.onToggleOpen;
    var defaultProps = __assign({}, ComponentToWrap.defaultProps, { isInitiallyOpen: false });
    delete defaultProps.isOpen;
    delete defaultProps.onToggleOpen;
    return _a = /** @class */ (function (_super) {
            __extends(ManagedOpenableComponent, _super);
            function ManagedOpenableComponent(props) {
                var _this = _super.call(this, props) || this;
                _this.displayName = "ManagedOpenableComponent::" + (ComponentToWrap.displayName ||
                    ComponentToWrap.name);
                _this.onToggleOpen = function (event) {
                    if (event) {
                        event.stopPropagation();
                    }
                    _this.setState(function (state) { return ({ isOpen: !state.isOpen }); });
                };
                _this.state = {
                    isOpen: Boolean(props.isInitiallyOpen)
                };
                return _this;
            }
            ManagedOpenableComponent.prototype.componentDidMount = function () {
                if (this.element && this.props.isInitiallyOpen && !dom_1.isInViewport(this.element)) {
                    this.setState(function (_) { return ({ isOpen: false }); });
                }
            };
            ManagedOpenableComponent.prototype.componentDidUpdate = function (_prevProps, prevState) {
                if (this.state.isOpen !== prevState.isOpen) {
                    if (typeof this.props.onToggledOpen === 'function') {
                        this.props.onToggledOpen(this.state.isOpen);
                    }
                }
            };
            ManagedOpenableComponent.prototype.render = function () {
                var _this = this;
                var _a = this.props, isInitiallyOpen = _a.isInitiallyOpen, className = _a.className, otherProps = __rest(_a, ["isInitiallyOpen", "className"]);
                var componentClassName = classNames(className);
                var managedProps = {
                    isOpen: this.state.isOpen,
                    onToggleOpen: this.onToggleOpen
                };
                return (React.createElement("div", { className: componentClassName, ref: function (el) { return _this.element = el; } },
                    React.createElement(ComponentToWrap, __assign({}, otherProps, managedProps))));
            };
            return ManagedOpenableComponent;
        }(React.Component)),
        _a.propTypes = propTypes,
        _a.defaultProps = defaultProps,
        _a;
}
exports.withManagedIsOpenState = withManagedIsOpenState;
//# sourceMappingURL=ManagedOpenableComponent.js.map
